import { Carousel } from 'pcln-carousel'
import { Flex, Text } from 'pcln-design-system'
import React from 'react'
import styled, { withTheme } from 'styled-components'

const StyledFlex = styled(Flex)`
  flex: 0 1;
  ${(props) => props.theme.mediaQueries[2]} {
    flex: 0 1 320px;
  }
`

const renderQuotes = (quotes, theme) =>
  quotes.slice(0, 3).map(({ quote, customer: { name, location } }, index) => (
    <StyledFlex
      theme={theme}
      key={index}
      px={[0, null, null, 2, 0]}
      py={[4, null, null, 0]}
      flexDirection='column'
      justifyContent='space-between'
      lineHeight={1.4}
      textAlign='center'
    >
      <Text.span fontSize={3} mb={3}>
        {'\u201C'}
        {quote}
        {'\u201D'}
      </Text.span>
      <Text.span bold fontSize={1}>
        {'- '}
        {name}
        {location ? `, ${location}` : ''}
      </Text.span>
    </StyledFlex>
  ))

const renderQuoteCards = (quotes) =>
  quotes.map(({ quote, customer: { name, location } }, index) => (
    <Flex
      key={index}
      p={[2, 3]}
      pb={['24px', null]}
      flexDirection='column'
      justifyContent='space-between'
      textAlign='center'
      bg='priceSecondary.light'
      borderRadius='xl'
      height='200px'
      overflow='hidden'
    >
      <Text mt={[null, '12px']} textStyle='paragraph2'>{`${'\u201C'}${quote}${'\u201D'}`}</Text>
      <Text mb={[null, '12px']} textStyle='paragraph2'>{`-${name}${location ? `, ${location}` : ''}`}</Text>
    </Flex>
  ))

const Quotes = ({
  showInCarouselMode = false,
  variant = 'default',
  contents,
  maxWidth = 1086,
  theme,
}) => {
  const quotes = variant === 'cardCarousel' ? renderQuoteCards(contents) : renderQuotes(contents, theme)

  if (variant === 'carousel' || showInCarouselMode) {
    return (
      <Flex color='primary' m='auto' p={2}>
        <Carousel
          arrowsPosition='side'
          currentSlide={0}
          displayArrowsMobile={false}
          slideSpacing={3}
          mobileVisibleSlides={[1.2, 2.2, 2.2]}
          visibleSlides={3}
        >
          {quotes}
        </Carousel>
      </Flex>
    )
  } else if (variant === 'cardCarousel') {
    return (
      <Carousel
        currentSlide={0}
        displayArrowsMobile={false}
        mobileVisibleSlides={[1.2, null, 2.2]}
        visibleSlides={3}
      >
        {quotes}
      </Carousel>
    )
  } else {
    return (
      <Flex color='primary' height={['100%', null, null, 275]}>
        <Flex
          maxWidth={maxWidth}
          justifyContent='space-between'
          m='auto'
          flexDirection={['column', null, null, 'row']}
        >
          {quotes}
        </Flex>
      </Flex>
    )
  }
}

const QuotesWithTheme = withTheme(Quotes)
export { QuotesWithTheme as Quotes }
export default QuotesWithTheme
